/**
 * 参照する際などにあたって住所文字列の変換をする。
 * @param value 住所など変換をかけたい文字列。
 */
 export function convertLetter(value: string) {
  // 大きい「ケ」を「ヶ」に変更する。
  return value.replace(/ケ/g, 'ヶ');
}
